module.exports = __webpack_public_path__ + "img/back.f7ccb669.jpg";